<template>
  <div>
      <a-back-top :target=targetEle></a-back-top>
   
  </div>
</template>
<script>
export default {
  data(){
    return{
      
    }
  },
  methods:{
    targetEle(){
      return document.querySelector('#app')
    }
  }
}
</script>
